/////////////////////////////////////////////
//Dependencies
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { PartnerCard } from "../Modules/partners/PartnerCard";

/////////////////////////////////////////////
//CSS
import "./css/Partner.css";


/////////////////////////////////////////////
export default function Partner() {
    const { t } = useTranslation();
    const pageTitle = "Plassys ▪ " + t("navbar.Contact");
    const pageDescription = "PLASSYS - " + t("navbar.ContactDD.Partner");

    // Liste des partenaires
    const partners = [
        {
            logo: "/img/marques/APSY.png",
            logoAlt: "ApSy – Application-systeme.com",
            name: "ApSy – Application Système",
            badge: t("partner.apsy.badge"),
            desc: t("partner.apsy.desc"),
            scopeTitle: t("partner.scopeTitle"),
            scopes: [
                t("partner.apsy.scope1"),
                t("partner.apsy.scope2"),
                t("partner.apsy.scope3"),
                t("partner.apsy.scope4"),
            ],
            location: "France",
            website: "https://www.application-systeme.com",
            websiteLabel: "www.application-systeme.com",
            // context: t("partner.apsy.context"),
            contactPerson: "François HAMON",
            phone: "+ 33 (0) 5 61 87 15 99",
            email: "fhamon@application-systeme.com",
            address: "1 Allée de L'Orchidée, Zone d'Activité Activestre, 31390 - CARBONNE – France",
        },
    ];

    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <link rel="canonical" href="https://plassys.com/contact/partners" />
            </Helmet>

            <div className="partner-container">
                <h1 className="title-contact maj">{t("partner.title")}</h1>

                <div className="contact-container-partner">
                    <p className="partner-page-intro">{t("partner.intro")}</p>

                    <div className="partner-list">
                        {partners.map((p) => (
                            <PartnerCard key={p.name} {...p} />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}
